var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBxPlusCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bx-plus-circle.svg"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.58337 4.08203H6.41671V6.41536H4.08337V7.58203H6.41671V9.91537H7.58337V7.58203H9.91671V6.41536H7.58337V4.08203Z",
    fill: "#0B110B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.99996 1.16797C3.78346 1.16797 1.16663 3.7848 1.16663 7.0013C1.16663 10.2178 3.78346 12.8346 6.99996 12.8346C10.2165 12.8346 12.8333 10.2178 12.8333 7.0013C12.8333 3.7848 10.2165 1.16797 6.99996 1.16797ZM6.99996 11.668C4.42688 11.668 2.33329 9.57439 2.33329 7.0013C2.33329 4.42822 4.42688 2.33464 6.99996 2.33464C9.57304 2.33464 11.6666 4.42822 11.6666 7.0013C11.6666 9.57439 9.57304 11.668 6.99996 11.668Z",
    fill: "#0B110B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxPlusCircle);
export default __webpack_public_path__ + "static/media/bx-plus-circle.3b872ff10a0b54922a107b3397101e50.svg";
export { ForwardRef as ReactComponent };